import React from 'react'
import PublicDetails from '../../Components/publicDetailsComponent/publicDetails.tsx'

function PublicDetailsPage() {
  return (
    <div>
        <PublicDetails />
    </div>
  )
}

export default PublicDetailsPage